import { Component, OnInit, OnDestroy, Input, AfterContentInit, AfterViewInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

import { FesBaseComponent } from '../../../shared/components/fes-base.component';
import { AppState } from '../../../core';
import { ScoutPath, ScoutPathComment } from '../../../core/models';
import { ScoutTaskDoc } from '../../../core/schema/scout-task-schema';
import { ScoutTaskService } from '../../../core/services';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmModalComponent } from '../../../shared/components/confirm-modal/confirm-modal.component';


@Component({
  selector: 'app-scout-path-comments',
  templateUrl: './scout-path-comments.component.html',
  styleUrls: ['./scout-path-comments.component.scss']
})
export class ScoutPathCommentsComponent  extends FesBaseComponent implements OnInit, OnDestroy {

  @Input() scoutTaskDoc : ScoutTaskDoc

  @Input() set scoutPath ( sp: ScoutPath){
    this._scoutPath = sp
    this.updateState()
  }
  _scoutPath : ScoutPath
  get scoutPath() { return this._scoutPath }

  comment = new FormControl('');

  someCommentsDeleted = false
  isEditing = false
  isSaving = false
  showDeleted = false
  
  constructor( appState: AppState, protected scoutTaskService : ScoutTaskService, protected modalService : BsModalService ) { 
    super(appState)
    this.comment.setValidators( Validators.required )
  }
  
  ngOnInit() : void {
    if ( this.scoutPath?.comments == null ) {
      this.scoutTaskDoc.atomicUpdate( (scoutTask) => {
        let scoutPath = scoutTask.scoutPaths?.find(sp=>sp.id==this.scoutPath.id)
        if ( scoutPath ) {
          scoutPath.comments = []
        }
        return scoutTask
      }).then( 
        doc => console.log('Initialized empty comments array for ' + this.scoutTaskDoc.buildingId + ' path ' + (this.scoutPath.id)), 
        error => this.scoutTaskService.publishError(error,this)
      ) 
    }
    this.updateState()
  }

  ngOnDestroy(): void {
    this.destroy()
  }


  isModified = () => {
    return this.isEditing && this.comment?.valid // zero length invalid
  }

  async askDiscardEdits(acceptDiscardFn: () => void) {
    let initialState = {
      onYes: acceptDiscardFn,
      question: 'Discard unsaved scout path comments?',
      focusOnNo: true,
      yesStyle: 'btn btn-danger'
    }
    this.modalService.config.animated = false    
    this.modalService.show(ConfirmModalComponent, { initialState });
  }


  updateState() {
    // only force sync if not "live" mode
    // this.scoutTaskService.sync() 
    this.someCommentsDeleted = this.scoutPath?.comments.some(c=>c.archived)
  }

  async onSaveComment() {
    this.isSaving = true
    try {
        this.isEditing = false
        await this.scoutTaskDoc.atomicUpdate( (taskDoc) => {
          let comment = new ScoutPathComment()
          comment.timestamp = this.scoutTaskService.nowTimeStamp(), 
          comment.archived = false
          comment.text = this.comment.value
          comment.userId = this.appState.getUser()._id
          let scoutPath = taskDoc.scoutPaths?.find(sp=>sp.id==this.scoutPath.id)
          if ( !scoutPath.comments ) {
              scoutPath.comments = []
          }
          scoutPath.comments.push(comment)
          return taskDoc
        })
    } catch ( error ) {
      this.isEditing = true
      this.scoutTaskService.publishError(error,this)
      return false
    } finally {
      this.updateState()
      this.isSaving = false;
    }
  }

  onCancelComment() : void {
    this.isEditing = false
    this.comment.setValue('')
  }

  async archive(commentIndex: number, bArchive : boolean ) {
    this.isSaving = true
    try {
      const updatedDoc = await this.scoutTaskDoc.atomicUpdate( (scoutTask) => {
        let scoutPath = scoutTask.scoutPaths?.find(sp=>sp.id==this.scoutPath.id)
        scoutPath.comments[commentIndex].archived = bArchive
        return scoutTask
      })
      this.scoutTaskService.publishSuccess((bArchive?'Deleted':'Restored') + ' comment',this)
      return true
    } catch ( error ) {
      this.scoutTaskService.publishError(error,this)
      return false
    } finally {
      this.updateState()
      this.isSaving = false;
    }
  }

  showDeletedChecked(val: any){
    this.showDeleted = val
 }

}
